/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _path7, _path8, _circle4, _circle5, _circle6, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle7, _circle8, _circle9, _circle10, _path36, _path37, _circle11, _circle12, _circle13, _circle14, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _circle15, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _circle16, _circle17, _circle18, _circle19, _circle20, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _circle21, _circle22, _circle23, _path93, _path94, _path95, _circle24, _circle25, _circle26, _path96, _circle27, _circle28, _circle29, _circle30, _circle31, _path97, _path98, _path99, _path100, _circle32, _path101, _circle33, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _circle34, _circle35, _circle36, _path125, _path126, _path127, _path128, _path129, _circle37, _path130, _path131, _circle38, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _circle39, _path142, _circle40, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _circle41, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _circle42, _circle43, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _circle44, _path203, _path204;
const FolderShared = /*#__PURE__*/React.forwardRef(function FolderShared(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderShared.propTypes = iconPropTypes;
}
const Folders = /*#__PURE__*/React.forwardRef(function Folders(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28H6a2.0021 2.0021 0 01-2-2V11A2.0021 2.0021 0 016 9h5.6665a2.0119 2.0119 0 011.2007.4L16.3335 12H26a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM11.6665 11H5.9985L6 26H26V14H15.6665zM28 9H17.6665l-4-3H6V4h7.6665a2.0119 2.0119 0 011.2007.4L18.3335 7H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Folders.propTypes = iconPropTypes;
}
const ForecastHail = /*#__PURE__*/React.forwardRef(function ForecastHail(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "14.5",
    cy: "23.5",
    r: "1.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "11.5",
    cy: "19.5",
    r: "1.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "19.5",
    r: "1.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.964 14.5H18.036V16.499H12.964z",
    transform: "rotate(-45 15.5 15.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.964 14.5H24.035999999999998V16.499H18.964z",
    transform: "rotate(-45 21.5 15.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastHail.propTypes = iconPropTypes;
}
const ForecastHail_30 = /*#__PURE__*/React.forwardRef(function ForecastHail_30(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.964 13.5H14.036000000000001V15.499H8.964z",
    transform: "rotate(-45 11.5 14.5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.379 14.5H17.622V16.499H15.379z",
    transform: "rotate(-44.995 16.5 15.5)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "22.5",
    r: "1.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "18.5",
    r: "1.5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "18.5",
    r: "1.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastHail_30.propTypes = iconPropTypes;
}
const ForecastLightning = /*#__PURE__*/React.forwardRef(function ForecastLightning(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastLightning.propTypes = iconPropTypes;
}
const ForecastLightning_30 = /*#__PURE__*/React.forwardRef(function ForecastLightning_30(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastLightning_30.propTypes = iconPropTypes;
}
const Fork = /*#__PURE__*/React.forwardRef(function Fork(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,6c0,1.8584,1.2798,3.4106,3,3.8579v5.1421h-14v-5.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v5.1421c0,1.103.897,2,2,2h6v5.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4s4-1.7944,4-4c0-1.8584-1.2798-3.4106-3-3.8579v-5.1421h6c1.103,0,2-.897,2-2v-5.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4Zm-14,0c0-1.103.897-2,2-2s2,.897,2,2c0,1.103-.897,2-2,2s-2-.897-2-2Zm12,20c0,1.103-.897,2-2,2s-2-.897-2-2c0-1.103.897-2,2-2s2,.897,2,2ZM26,6c0,1.103-.897,2-2,2s-2-.897-2-2c0-1.103.897-2,2-2s2,.897,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fork.propTypes = iconPropTypes;
}
const ForkNode = /*#__PURE__*/React.forwardRef(function ForkNode(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M26 21H30V23H26zM26 9H30V11H26zM24 11L24 9 20 9 20 4 14 4 14 28 20 28 20 23 24 23 24 21 20 21 20 11 24 11zM10.1719 15L2 15 2 17 10.1719 17 7.5859 19.5859 9 21 14 16 9 11 7.5859 12.4141 10.1719 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForkNode.propTypes = iconPropTypes;
}
const Forum = /*#__PURE__*/React.forwardRef(function Forum(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8 C30,6.8,29.2,6,28,6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forum.propTypes = iconPropTypes;
}
const Forward_10 = /*#__PURE__*/React.forwardRef(function Forward_10(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forward_10.propTypes = iconPropTypes;
}
const Forward_30 = /*#__PURE__*/React.forwardRef(function Forward_30(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forward_30.propTypes = iconPropTypes;
}
const Forward_5 = /*#__PURE__*/React.forwardRef(function Forward_5(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forward_5.propTypes = iconPropTypes;
}
const Fragile = /*#__PURE__*/React.forwardRef(function Fragile(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fragile.propTypes = iconPropTypes;
}
const Friendship = /*#__PURE__*/React.forwardRef(function Friendship(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10H7a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V16H12V28H8V19H6V13a1.0009 1.0009 0 011-1H25a1.0009 1.0009 0 011 1v6H24v9H20V16H18V28a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0025 10zM10 9a4 4 0 114-4A4.0042 4.0042 0 0110 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0010 3zM22 9a4 4 0 114-4A4.0042 4.0042 0 0122 9zm0-6a2 2 0 102 2A2.0023 2.0023 0 0022 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Friendship.propTypes = iconPropTypes;
}
const FruitBowl = /*#__PURE__*/React.forwardRef(function FruitBowl(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FruitBowl.propTypes = iconPropTypes;
}
const Function = /*#__PURE__*/React.forwardRef(function Function(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Function.propTypes = iconPropTypes;
}
const Function_2 = /*#__PURE__*/React.forwardRef(function Function_2(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3,13l-1.3,13.2c-.1.9926-.9,1.8-1.9,1.8h-5.1v-2h5l1.3-13h-4.3v-2h4.5l.5-5.2c.0916-1.0019,1-1.8,2-1.8h5v2h-5l-.5,5h4.5v2h-4.7ZM16,19v7c0,1.1.9,2,2,2h2v-2h-2v-7h2v-2h-2c-1.1,0-2,.9-2,2ZM26,17h-2v2h2v7h-2v2h2c1.1,0,2-.9,2-2v-7c0-1.1-.9-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Function_2.propTypes = iconPropTypes;
}
const FunctionMath = /*#__PURE__*/React.forwardRef(function FunctionMath(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FunctionMath.propTypes = iconPropTypes;
}
const WatsonHealthFusionBlender = /*#__PURE__*/React.forwardRef(function WatsonHealthFusionBlender(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthFusionBlender.propTypes = iconPropTypes;
}
const GameConsole = /*#__PURE__*/React.forwardRef(function GameConsole(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "14",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "14",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GameConsole.propTypes = iconPropTypes;
}
const GameWireless = /*#__PURE__*/React.forwardRef(function GameWireless(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "18",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "18",
    r: "1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GameWireless.propTypes = iconPropTypes;
}
const Gamification = /*#__PURE__*/React.forwardRef(function Gamification(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gamification.propTypes = iconPropTypes;
}
const GasStation = /*#__PURE__*/React.forwardRef(function GasStation(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H15V12H8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GasStation.propTypes = iconPropTypes;
}
const GasStationFilled = /*#__PURE__*/React.forwardRef(function GasStationFilled(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H15V12H8z",
    "data-icon-path": "inner-path"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GasStationFilled.propTypes = iconPropTypes;
}
const Gateway = /*#__PURE__*/React.forwardRef(function Gateway(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gateway.propTypes = iconPropTypes;
}
const GatewayApi = /*#__PURE__*/React.forwardRef(function GatewayApi(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayApi.propTypes = iconPropTypes;
}
const GatewayMail = /*#__PURE__*/React.forwardRef(function GatewayMail(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayMail.propTypes = iconPropTypes;
}
const GatewayPublic = /*#__PURE__*/React.forwardRef(function GatewayPublic(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayPublic.propTypes = iconPropTypes;
}
const GatewaySecurity = /*#__PURE__*/React.forwardRef(function GatewaySecurity(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewaySecurity.propTypes = iconPropTypes;
}
const GatewayUserAccess = /*#__PURE__*/React.forwardRef(function GatewayUserAccess(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H19V20a1.0011 1.0011 0 00-1-1H14a1.0011 1.0011 0 00-1 1v2H11V20a3.0033 3.0033 0 013-3h4a3.0033 3.0033 0 013 3zM16 16a3.5 3.5 0 113.5-3.5A3.5041 3.5041 0 0116 16zm0-5a1.5 1.5 0 101.5 1.5A1.5017 1.5017 0 0016 11z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayUserAccess.propTypes = iconPropTypes;
}
const GatewayVpn = /*#__PURE__*/React.forwardRef(function GatewayVpn(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayVpn.propTypes = iconPropTypes;
}
const Gears = /*#__PURE__*/React.forwardRef(function Gears(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M28 21.9847c0-.4595-.0568-.9053-.155-1.3354l2.155-.8273-.7167-1.8671-2.2063.8469c-.4529-.7197-1.0501-1.3392-1.7568-1.8106l.9695-2.1777-1.8271-.8135-.9706 2.1801c-.478-.123-.9761-.1954-1.492-.1954s-1.014.0724-1.492.1954l-.9706-2.1801-1.8271.8135.9695 2.1777c-.7067.4714-1.3039 1.0909-1.7568 1.8106l-2.2063-.8469-.7167 1.8671 2.155.8273c-.0983.4302-.155.8759-.155 1.3354 0 .4396.0507.8672.1408 1.2802l-2.1408.9531.8135 1.8271 2.08-.9261c.442.7173 1.0259 1.3374 1.7191 1.8134l-.9023 2.3508 1.8671.7167.856-2.2299c.5004.1357 1.0239.2146 1.5666.2146s1.0662-.0789 1.5666-.2146l.856 2.2299 1.8671-.7167-.9023-2.3508c.6932-.476 1.2772-1.0961 1.7191-1.8134l2.08.9261.8135-1.8271-2.1408-.9531c.0901-.413.1408-.8406.1408-1.2802zm-6 4c-2.2061 0-4-1.7944-4-4s1.7939-4 4-4 4 1.7944 4 4-1.7939 4-4 4zM13.471 14.8852l1.4788 1.4788 1.4142-1.4142-1.4788-1.4787c.5146-.7222.871-1.5616 1.0245-2.471h2.0903v-2h-2.0903c-.1535-.9094-.5098-1.7488-1.0245-2.471l1.4788-1.4788-1.4142-1.4142-1.4788 1.4788c-.7222-.5146-1.5616-.871-2.471-1.0245v-2.0903h-2v2.0903c-.9094.1535-1.7488.5099-2.471 1.0245l-1.4788-1.4788-1.4142 1.4142 1.4788 1.4788c-.5146.7222-.871 1.5616-1.0245 2.471H2v2h2.0903c.1535.9094.5098 1.7488 1.0245 2.471l-1.4788 1.4787 1.4142 1.4142 1.4788-1.4788c.7222.5146 1.5616.871 2.471 1.0245v2.0903h2v-2.0903c.9094-.1535 1.7488-.5098 2.471-1.0245zm-7.471-4.8852c0-2.2056 1.7939-4 4-4s4 1.7944 4 4-1.7939 4-4 4-4-1.7944-4-4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gears.propTypes = iconPropTypes;
}
const Gem = /*#__PURE__*/React.forwardRef(function Gem(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gem.propTypes = iconPropTypes;
}
const GemReference = /*#__PURE__*/React.forwardRef(function GemReference(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GemReference.propTypes = iconPropTypes;
}
const GenderFemale = /*#__PURE__*/React.forwardRef(function GenderFemale(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GenderFemale.propTypes = iconPropTypes;
}
const GenderMale = /*#__PURE__*/React.forwardRef(function GenderMale(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GenderMale.propTypes = iconPropTypes;
}
const GeneratePdf = /*#__PURE__*/React.forwardRef(function GeneratePdf(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GeneratePdf.propTypes = iconPropTypes;
}
const Gif = /*#__PURE__*/React.forwardRef(function Gif(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gif.propTypes = iconPropTypes;
}
const Gift = /*#__PURE__*/React.forwardRef(function Gift(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gift.propTypes = iconPropTypes;
}
const GlobalLoanAndTrial = /*#__PURE__*/React.forwardRef(function GlobalLoanAndTrial(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m15,22l-1.4099,1.4102,2.5798,2.5898H4V8h-2v18c0,1.1025.8972,2,2,2h12.1699l-2.5798,2.5898,1.4099,1.4102,5-5-5-5Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m24,20H8c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h16c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-16-6v4h16v-4H8Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m28,4h-12.1699l2.5801-2.5898L17,0l-5,5,5,5,1.4102-1.4102-2.5801-2.5898h12.1699v18h2V6c0-1.1025-.8972-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GlobalLoanAndTrial.propTypes = iconPropTypes;
}
const Globe = /*#__PURE__*/React.forwardRef(function Globe(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Globe.propTypes = iconPropTypes;
}
const Gradient = /*#__PURE__*/React.forwardRef(function Gradient(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gradient.propTypes = iconPropTypes;
}
const GraphicalDataFlow = /*#__PURE__*/React.forwardRef(function GraphicalDataFlow(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GraphicalDataFlow.propTypes = iconPropTypes;
}
const Grid = /*#__PURE__*/React.forwardRef(function Grid(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Grid.propTypes = iconPropTypes;
}
const Group = /*#__PURE__*/React.forwardRef(function Group(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Group.propTypes = iconPropTypes;
}
const GroupAccess = /*#__PURE__*/React.forwardRef(function GroupAccess(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19H6V17a3.0033 3.0033 0 013-3h5v2H9a1.0011 1.0011 0 00-1 1zM12 13a4 4 0 114-4A4.0045 4.0045 0 0112 13zm0-6a2 2 0 102 2A2.0021 2.0021 0 0012 7zM20 20a4 4 0 114-4A4.0045 4.0045 0 0120 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0020 14zM26 26H24V24a1.0011 1.0011 0 00-1-1H17a1.0011 1.0011 0 00-1 1v2H14V24a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupAccess.propTypes = iconPropTypes;
}
const GroupAccount = /*#__PURE__*/React.forwardRef(function GroupAccount(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11H11a3 3 0 00-3 3v4h2V14a1 1 0 011-1h6a1 1 0 011 1v1h2V14A3 3 0 0017 11zM10 6a4 4 0 104-4A4 4 0 0010 6zm6 0a2 2 0 11-2-2A2 2 0 0116 6zM22 27H16a2.0021 2.0021 0 01-2-2V19a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0122 27zm-6-8v6h6V19zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupAccount.propTypes = iconPropTypes;
}
const GroupPresentation = /*#__PURE__*/React.forwardRef(function GroupPresentation(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "22",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupPresentation.propTypes = iconPropTypes;
}
const GroupResource = /*#__PURE__*/React.forwardRef(function GroupResource(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H10a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2H22a2.0021 2.0021 0 012 2V22A2.0021 2.0021 0 0122 24zM10 10V22H22V10zM8 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H8V4H4V28H8zM28 30H24V28h4V4H24V2h4a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupResource.propTypes = iconPropTypes;
}
const GroupSecurity = /*#__PURE__*/React.forwardRef(function GroupSecurity(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H9V19a3.0033 3.0033 0 013-3h6v2H12a1.0011 1.0011 0 00-1 1zM15 15a4 4 0 114-4A4.0045 4.0045 0 0115 15zm0-6a2 2 0 102 2A2.0021 2.0021 0 0015 9zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 16zM30 28H28V26a1.0011 1.0011 0 00-1-1H21a1.0011 1.0011 0 00-1 1v2H18V26a3.0033 3.0033 0 013-3h6a3.0033 3.0033 0 013 3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupSecurity.propTypes = iconPropTypes;
}
const GroupObjects = /*#__PURE__*/React.forwardRef(function GroupObjects(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupObjects.propTypes = iconPropTypes;
}
const GroupObjectsNew = /*#__PURE__*/React.forwardRef(function GroupObjectsNew(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupObjectsNew.propTypes = iconPropTypes;
}
const GroupObjectsSave = /*#__PURE__*/React.forwardRef(function GroupObjectsSave(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupObjectsSave.propTypes = iconPropTypes;
}
const Growth = /*#__PURE__*/React.forwardRef(function Growth(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Growth.propTypes = iconPropTypes;
}
const Gui = /*#__PURE__*/React.forwardRef(function Gui(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "8",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "8",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gui.propTypes = iconPropTypes;
}
const GuiManagement = /*#__PURE__*/React.forwardRef(function GuiManagement(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "8",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "8",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GuiManagement.propTypes = iconPropTypes;
}
const QH = /*#__PURE__*/React.forwardRef(function QH(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QH.propTypes = iconPropTypes;
}
const Hail = /*#__PURE__*/React.forwardRef(function Hail(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "25.5",
    r: "1.5"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.5",
    cy: "29.5",
    r: "1.5"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.499",
    cy: "29.5",
    r: "1.5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hail.propTypes = iconPropTypes;
}
const WatsonHealthHangingProtocol = /*#__PURE__*/React.forwardRef(function WatsonHealthHangingProtocol(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHangingProtocol.propTypes = iconPropTypes;
}
const Harbor = /*#__PURE__*/React.forwardRef(function Harbor(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Harbor.propTypes = iconPropTypes;
}
const HardwareSecurityModule = /*#__PURE__*/React.forwardRef(function HardwareSecurityModule(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "7.5",
    r: "1.5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4143 20H9V14.5857l6.03-6.03A5.3518 5.3518 0 0115 8a6 6 0 116 6 5.3583 5.3583 0 01-.5559-.03zM11 18h2.5857l6.1706-6.1709.5174.0957A3.935 3.935 0 0021 12a4.0507 4.0507 0 10-3.925-3.2729l.0952.5166L11 15.4143zM28 20H19v2h9v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HardwareSecurityModule.propTypes = iconPropTypes;
}
const Hashtag = /*#__PURE__*/React.forwardRef(function Hashtag(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hashtag.propTypes = iconPropTypes;
}
const Haze = /*#__PURE__*/React.forwardRef(function Haze(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.5H28.5V25.5H24.5z",
    transform: "rotate(45 26.5 24.5)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H32V17H28z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5H28.5V8.5H24.5z",
    transform: "rotate(-45 26.5 7.5)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H11.5V8.5H7.5z",
    transform: "rotate(-135 9.5 7.5)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Haze.propTypes = iconPropTypes;
}
const HazeNight = /*#__PURE__*/React.forwardRef(function HazeNight(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HazeNight.propTypes = iconPropTypes;
}
const Hd = /*#__PURE__*/React.forwardRef(function Hd(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hd.propTypes = iconPropTypes;
}
const HdFilled = /*#__PURE__*/React.forwardRef(function HdFilled(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HdFilled.propTypes = iconPropTypes;
}
const Hdr = /*#__PURE__*/React.forwardRef(function Hdr(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hdr.propTypes = iconPropTypes;
}
const Headphones = /*#__PURE__*/React.forwardRef(function Headphones(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Headphones.propTypes = iconPropTypes;
}
const Headset = /*#__PURE__*/React.forwardRef(function Headset(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Headset.propTypes = iconPropTypes;
}
const HealthCross = /*#__PURE__*/React.forwardRef(function HealthCross(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HealthCross.propTypes = iconPropTypes;
}
const Hearing = /*#__PURE__*/React.forwardRef(function Hearing(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hearing.propTypes = iconPropTypes;
}
const HeatMap = /*#__PURE__*/React.forwardRef(function HeatMap(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMap.propTypes = iconPropTypes;
}
const HeatMap_02 = /*#__PURE__*/React.forwardRef(function HeatMap_02(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "20",
    r: "2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "12",
    r: "2"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "19",
    r: "1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMap_02.propTypes = iconPropTypes;
}
const HeatMap_03 = /*#__PURE__*/React.forwardRef(function HeatMap_03(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMap_03.propTypes = iconPropTypes;
}
const HeatMapStocks = /*#__PURE__*/React.forwardRef(function HeatMapStocks(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMapStocks.propTypes = iconPropTypes;
}
const Helicopter = /*#__PURE__*/React.forwardRef(function Helicopter(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Helicopter.propTypes = iconPropTypes;
}
const Help = /*#__PURE__*/React.forwardRef(function Help(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
      cx: "8",
      cy: "11.8",
      r: ".8"
    })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
      d: "M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1 v2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23.5",
    r: "1.5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Help.propTypes = iconPropTypes;
}
const HelpFilled = /*#__PURE__*/React.forwardRef(function HelpFilled(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HelpFilled.propTypes = iconPropTypes;
}
const HelpDesk = /*#__PURE__*/React.forwardRef(function HelpDesk(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HelpDesk.propTypes = iconPropTypes;
}
const HexagonOutline = /*#__PURE__*/React.forwardRef(function HexagonOutline(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23,29h-14c-.3555,0-.6846-.189-.8638-.4961L1.1362,16.5039c-.1816-.3113-.1816-.6965,0-1.0078L8.1362,3.4961c.1792-.3071.5083-.4961.8638-.4961h14c.3555,0,.6846.189.8638.4961l7,12c.1816.3113.1816.6965,0,1.0078l-7,12c-.1792.3071-.5083.4961-.8638.4961Zm-13.4258-2h12.8516l6.4165-11-6.4165-11h-12.8516l-6.4165,11,6.4165,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonOutline.propTypes = iconPropTypes;
}
const HexagonSolid = /*#__PURE__*/React.forwardRef(function HexagonSolid(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30.8508,15.4487l-6.9641-11.9165c-.1926-.3301-.5437-.5322-.9224-.5322h-13.9287c-.3787,0-.7297.2021-.9224.5322L1.1492,15.4487c-.199.3403-.199.7622,0,1.1025l6.9641,11.9165c.1926.3301.5437.5322.9224.5322h13.9287c.3787,0,.7297-.2021.9224-.5322l6.9641-11.9165c.199-.3403.199-.7622,0-1.1025Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonSolid.propTypes = iconPropTypes;
}
const HexagonVerticalOutline = /*#__PURE__*/React.forwardRef(function HexagonVerticalOutline(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m3,23v-14c0-.3555.189-.6846.4961-.8638L15.4961,1.1362c.3113-.1816.6965-.1816,1.0078,0l12,7c.3071.1792.4961.5083.4961.8638v14c0,.3555-.189.6846-.4961.8638l-12,7c-.3113.1816-.6965.1816-1.0078,0l-12-7c-.3071-.1792-.4961-.5083-.4961-.8638Zm2-13.4258v12.8516l11,6.4165,11-6.4165v-12.8516l-11-6.4165-11,6.4165Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonVerticalOutline.propTypes = iconPropTypes;
}
const HexagonVerticalSolid = /*#__PURE__*/React.forwardRef(function HexagonVerticalSolid(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16.5513,30.8508l11.9165-6.9641c.3301-.1926.5322-.5437.5322-.9224v-13.9287c0-.3787-.2021-.7297-.5322-.9224L16.5513,1.1492c-.3403-.199-.7622-.199-1.1025,0L3.5322,8.1133c-.3301.1926-.5322.5437-.5322.9224v13.9287c0,.3787.2021.7297.5322.9224l11.9165,6.9641c.3403.199.7622.199,1.1025,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonVerticalSolid.propTypes = iconPropTypes;
}
const QHintonPlot = /*#__PURE__*/React.forwardRef(function QHintonPlot(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QHintonPlot.propTypes = iconPropTypes;
}
const WatsonHealthHl7Attributes = /*#__PURE__*/React.forwardRef(function WatsonHealthHl7Attributes(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHl7Attributes.propTypes = iconPropTypes;
}
const WatsonHealthHoleFilling = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFilling(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHoleFilling.propTypes = iconPropTypes;
}
const WatsonHealthHoleFillingCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "19",
    r: "4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHoleFillingCursor.propTypes = iconPropTypes;
}
const Home = /*#__PURE__*/React.forwardRef(function Home(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Home.propTypes = iconPropTypes;
}
const HorizontalView = /*#__PURE__*/React.forwardRef(function HorizontalView(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HorizontalView.propTypes = iconPropTypes;
}
const Hospital = /*#__PURE__*/React.forwardRef(function Hospital(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hospital.propTypes = iconPropTypes;
}
const HospitalBed = /*#__PURE__*/React.forwardRef(function HospitalBed(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HospitalBed.propTypes = iconPropTypes;
}
const Hotel = /*#__PURE__*/React.forwardRef(function Hotel(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hotel.propTypes = iconPropTypes;
}
const Hourglass = /*#__PURE__*/React.forwardRef(function Hourglass(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V21H15zM15 23H17V25H15z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hourglass.propTypes = iconPropTypes;
}
const Html = /*#__PURE__*/React.forwardRef(function Html(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Html.propTypes = iconPropTypes;
}
const HtmlReference = /*#__PURE__*/React.forwardRef(function HtmlReference(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HtmlReference.propTypes = iconPropTypes;
}
const Http = /*#__PURE__*/React.forwardRef(function Http(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Http.propTypes = iconPropTypes;
}
const Humidity = /*#__PURE__*/React.forwardRef(function Humidity(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Humidity.propTypes = iconPropTypes;
}
const HumidityAlt = /*#__PURE__*/React.forwardRef(function HumidityAlt(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HumidityAlt.propTypes = iconPropTypes;
}
const Hurricane = /*#__PURE__*/React.forwardRef(function Hurricane(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hurricane.propTypes = iconPropTypes;
}
const HybridNetworking = /*#__PURE__*/React.forwardRef(function HybridNetworking(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HybridNetworking.propTypes = iconPropTypes;
}
const HybridNetworkingAlt = /*#__PURE__*/React.forwardRef(function HybridNetworkingAlt(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HybridNetworkingAlt.propTypes = iconPropTypes;
}
const IbmAiOnZ = /*#__PURE__*/React.forwardRef(function IbmAiOnZ(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m28,26c-.7384,0-1.3762.4047-1.7226,1h-5.2774l7.7998-10.4004c.2275-.3027.2642-.708.0947-1.0469s-.5156-.5527-.8945-.5527h-10.1843c-.4141-1.1615-1.5138-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.3019,0,2.4016-.8385,2.8157-2h8.1843l-7.7998,10.4004c-.2275.3027-.2642.708-.0947,1.0469s.5156.5527.8945.5527h7.2774c.3464.5953.9842,1,1.7226,1,1.1046,0,2-.8954,2-2s-.8954-2-2-2Zm-13-9c-.5513,0-1-.4482-1-1s.4487-1,1-1,1,.4482,1,1-.4487,1-1,1Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m16,21h-2v4.5859L4.4139,16,14,6.4142v4.5858h2v-6h10v8h2V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2v22c0,1.1046.8954,2,2,2h12v-8ZM4,5h8.5858L4,13.5858V5Zm0,22v-8.5858l8.5858,8.5858H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAiOnZ.propTypes = iconPropTypes;
}
const IbmAiopsInsights = /*#__PURE__*/React.forwardRef(function IbmAiopsInsights(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 23L2 30 9 30 5.5 23zM26 15v2c1.1025 0 2 .8975 2 2v5c0 1.1025-.8975 2-2 2H10v2h16c2.2061 0 4-1.7939 4-4v-5c0-2.2056-1.7939-4-4-4z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m14,24c-.4463,0-.8389-.2959-.9614-.7251l-1.793-6.2749h-3.2456v-2h4c.4463,0,.8389.2959.9614.7251l1.0386,3.6348,3.0386-10.6348c.1226-.4292.5151-.7251.9614-.7251s.8389.2959.9614.7251l1.793,6.2749h3.2456v2h-4c-.4463,0-.8389-.2959-.9614-.7251l-1.0386-3.6348-3.0386,10.6348c-.1226.4292-.5151.7251-.9614.7251Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m4,13v-5c0-1.103.897-2,2-2h16v-2H6c-2.2056,0-4,1.7944-4,4v5c0,2.2056,1.7944,4,4,4v-2c-1.103,0-2-.897-2-2Z"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "5",
    r: "3"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAiopsInsights.propTypes = iconPropTypes;
}
const IbmApiConnect = /*#__PURE__*/React.forwardRef(function IbmApiConnect(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12c-1.1393,0-2.1624.484-2.8915,1.2505l-3.1586-1.7552c.0272-.162.05-.3257.05-.4954,0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,1.0923.5928,2.0405,1.4676,2.5651l-.8963,4.4782c-1.4501.2102-2.5713,1.4492-2.5713,2.9567,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-.0867-.0183-.1684-.0256-.2533l4.9317-2.2424c.7339.9048,1.8404,1.4957,3.0939,1.4957,2.2061,0,4-1.7939,4-4s-1.7939-4-4-4ZM12.9989,10.0002c.552,0,1.0004.4482,1.0004,1s-.4484,1-1.0004,1-1.0004-.4482-1.0004-1,.4484-1,1.0004-1ZM10.9982,22.0001c-.552,0-1.0004-.4482-1.0004-1s.4484-1,1.0004-1c.4135,0,.7687.2517.9209.6099l.0009.002c.0504.1194.0785.2505.0785.3881,0,.5518-.4484,1-1.0004,1ZM13.1545,18.9224c-.1838-.1906-.395-.3505-.6233-.4874l.8966-4.4782c.5893-.0854,1.1195-.3394,1.5463-.7159l3.1684,1.7599c-.0835.3213-.1418.6522-.1418.9993,0,.2355.0303.4633.0695.6877l-4.9158,2.2345ZM22.0022,18.0002c-1.1029,0-2.0007-.8975-2.0007-2s.8978-2,2.0007-2,2.0007.8975,2.0007,2-.8978,2-2.0007,2ZM27.0908,11.4079c.6175,1.4903.9125,3.0496.9092,4.5921-.0033,1.5629-.3128,3.1085-.9009,4.5475l1.7934.8965c.7238-1.7181,1.1039-3.5704,1.1075-5.444.0035-1.7996-.3405-3.6188-1.061-5.3572-2.2286-5.3799-7.4473-8.6357-12.939-8.6428-1.7888-.0023-3.6066.3401-5.3595,1.0661l.7655,1.8474c1.5025-.6221,3.0607-.9156,4.594-.9135,4.7072.0063,9.1801,2.7969,11.0908,7.4079ZM20.594,27.0868c-1.5026.6222-3.0607.9152-4.594.9132-4.7075-.0062-9.1802-2.797-11.0908-7.4076-.6175-1.4904-.9125-3.0498-.9092-4.5924.0033-1.5627.3128-3.1082.9009-4.5472l-1.7934-.8965c-.7237,1.718-1.1039,3.5702-1.1075,5.4437-.0035,1.7997.3404,3.619,1.061,5.3576,1.4775,3.5657,4.2683,6.1985,7.582,7.5705,1.6852.6977,3.5055,1.0695,5.357,1.0719,1.7887.0024,3.6064-.3399,5.3594-1.0658l-.7654-1.8474ZM25,23c-1.12,0-2,.88-2,2s.88,2,2,2,2-.88,2-2-.88-2-2-2ZM7,5c-1.12,0-2,.88-2,2s.88,2,2,2,2-.88,2-2-.88-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmApiConnect.propTypes = iconPropTypes;
}
const IbmAppConnectEnterprise = /*#__PURE__*/React.forwardRef(function IbmAppConnectEnterprise(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M22,19c-.2045,0-.404.0212-.597.0604l-2.5553-4.2578c.711-.7224,1.1523-1.7111,1.1523-2.8026,0-2.2061-1.7939-4-4-4s-4,1.7939-4,4c0,1.0931.4424,2.0834,1.1552,2.806l-3.111,5.1983c-.0151-.0003-.0291-.0043-.0443-.0043-1.12,0-2,.88-2,2s.88,2,2,2,2-.88,2-2c0-.3502-.0941-.6718-.2466-.9555l3.1263-5.2239c.3578.1053.7288.1794,1.1203.1794.3933,0,.7659-.0747,1.1251-.1809l2.5706,4.2833c-.428.5187-.6957,1.1741-.6957,1.8976,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3ZM14,12c0-1.1025.8975-2,2-2s2,.8975,2,2-.8975,2-2,2-2-.8975-2-2ZM22,23c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1ZM30,16.9995v-.0005h0c-.0005-7.7192-6.2805-13.999-14-13.999S2,9.2803,2,17c0,4.1558,2.0088,7.644,3.3611,8.8938,1.0293.9512,2.5835,2.1062,4.6389,2.1062,3.3086,0,6-2.6917,6-6,0-.834-.168-1.6416-.5-2.4006l-1.832.8008c.2197.5049.332,1.0432.332,1.5999,0,2.2056-1.7939,4-4,4s-4-1.7944-4-4,1.7939-4,4-4v-2c-2.5745,0-4.7689,1.6328-5.6187,3.9148-.2546-.9341-.3813-1.9031-.3813-2.9148,0-6.6167,5.3828-12,12-12s12,5.3833,12,12h.001c0,1.0518-.1367,2.0977-.4053,3.1084l1.9316.5156c.3145-1.1804.4734-2.3997.4727-3.624h0v-.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAppConnectEnterprise.propTypes = iconPropTypes;
}
const IbmAspera = /*#__PURE__*/React.forwardRef(function IbmAspera(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11c-.75,0-1.39.4-1.73,1h-10.27c-2.21,0-4,1.79-4,4,0,.73.21,1.41.56,2h-6.83c-.34-.6-.98-1-1.73-1-1.12,0-2,.88-2,2s.88,2,2,2c.75,0,1.39-.4,1.73-1h10.27c2.21,0,4-1.79,4-4,0-.73-.21-1.41-.56-2h6.83c.34.6.98,1,1.73,1,1.12,0,2-.88,2-2s-.88-2-2-2ZM18,16c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2ZM5.05,15h-2c0-7.29,5.08-12,12.95-12h10v2h-10c-6.75,0-10.95,3.83-10.95,10ZM16.05,29H6.05v-2h10c6.14,0,10.95-4.39,10.95-10h2c0,6.73-5.69,12-12.95,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAspera.propTypes = iconPropTypes;
}
const IbmBluepay = /*#__PURE__*/React.forwardRef(function IbmBluepay(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmBluepay.propTypes = iconPropTypes;
}
const IbmCloudant = /*#__PURE__*/React.forwardRef(function IbmCloudant(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26h5c3.86 0 7-3.14 7-7v-2h-2v2c0 2.76-2.24 5-5 5h-5v2zM20.25 14c-2.34 0-4.25-1.91-4.25-4.25 0-1.79 1.14-3.38 2.78-3.99.74-2.21 2.84-3.76 5.22-3.76s4.48 1.55 5.22 3.76c1.65.61 2.78 2.19 2.78 3.99 0 2.29-1.86 4.19-4.14 4.25h-7.61zm3.75-10c-1.64 0-3.08 1.17-3.42 2.77l-.14.64-.64.13c-1.04.21-1.8 1.14-1.8 2.2 0 1.24 1.01 2.26 2.25 2.26h7.58c1.18-.03 2.17-1.05 2.17-2.26 0-1.06-.76-1.99-1.8-2.2l-.64-.13-.14-.64c-.34-1.6-1.78-2.77-3.42-2.77zM4 14h2v-2c0-2.76 2.24-5 5-5h4v-2h-4c-3.86 0-7 3.14-7 7v2zM10 17h-6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2zm0 2v2h-6v-2h6zm0 4v2h-6v-2h6zm-6 6v-2h6v2H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudant.propTypes = iconPropTypes;
}
const IbmContentServices = /*#__PURE__*/React.forwardRef(function IbmContentServices(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmContentServices.propTypes = iconPropTypes;
}
const IbmDataPower = /*#__PURE__*/React.forwardRef(function IbmDataPower(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21c-2.7568,0-5-2.2432-5-5s2.2432-5,5-5,5,2.2432,5,5-2.2432,5-5,5ZM16,13c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3ZM27,25c0-1.1046-.8954-2-2-2s-2,.8954-2,2,.8954,2,2,2,2-.8954,2-2ZM5,7c0,1.1046.8954,2,2,2s2-.8954,2-2-.8954-2-2-2-2,.8954-2,2ZM30,16c0-7.7197-6.2803-14-14-14-1.8638,0-3.6758.3623-5.3857,1.0771l.7715,1.8457c1.4644-.6123,3.0166-.9229,4.6143-.9229,6.2803,0,11.4492,4.8496,11.959,11h-4.959v2h7v-1ZM21.3857,28.9229l-.7715-1.8457c-1.4639.6123-3.0166.9229-4.6143.9229-6.2798,0-11.4487-4.8496-11.9585-11h4.9585v-2H2v1c0,7.7197,6.2803,14,14,14,1.8643,0,3.6768-.3623,5.3857-1.0771Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataPower.propTypes = iconPropTypes;
}
const IbmDataProductExchange = /*#__PURE__*/React.forwardRef(function IbmDataProductExchange(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m24,21v2h1.7483c-2.2363,3.1196-5.8357,5-9.7483,5-6.6169,0-12-5.3833-12-12h-2c0,7.7197,6.2803,14,14,14,4.355,0,8.3743-2.001,11-5.3452v1.3452h2v-5h-5Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5046,11.6367l-5.9883-3.5c-.1594-.0933-.3381-.1387-.5164-.1367-.1699.002-.3394.0474-.4915.1357l-6.0117,3.5c-.3076.1792-.4968.5083-.4968.8643v7c0,.356.1892.6851.4968.8643l6.0117,3.5c.1555.0903.3176.1357.4915.1357.1743,0,.3604-.0454.5164-.1367l5.9883-3.5c.3069-.1792.4954-.5078.4954-.8633v-7c0-.3555-.1885-.6841-.4954-.8633Zm-6.4939-1.479l4.0076,2.3423-4.0076,2.3423-4.0232-2.3423,4.0232-2.3423Zm-5.0107,4.0815l4,2.3291v4.6855l-4-2.3291v-4.6855Zm6,7.0249v-4.6836l4-2.3379v4.6836l-4,2.3379Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-4.355,0-8.3743,2.001-11,5.3452v-1.3452h-2v5h5v-2h-1.7483c2.2363-3.1196,5.8357-5,9.7483-5,6.6169,0,12,5.3833,12,12h2c0-7.7197-6.2803-14-14-14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataProductExchange.propTypes = iconPropTypes;
}
const IbmDataReplication = /*#__PURE__*/React.forwardRef(function IbmDataReplication(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataReplication.propTypes = iconPropTypes;
}
const IbmDatastage = /*#__PURE__*/React.forwardRef(function IbmDatastage(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDatastage.propTypes = iconPropTypes;
}
const IbmDb2 = /*#__PURE__*/React.forwardRef(function IbmDb2(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m16,13c-3.4207,0-6,1.5049-6,3.5v8c0,1.9951,2.5793,3.5,6,3.5s6-1.5049,6-3.5v-8c0-1.9951-2.5793-3.5-6-3.5Zm0,2c2.4814,0,4,.9712,4,1.5s-1.5186,1.5-4,1.5-4-.9712-4-1.5,1.5186-1.5,4-1.5Zm0,11c-2.4814,0-4-.9712-4-1.5v-1.3525c1.0469.5342,2.4331.8525,4,.8525s2.9531-.3184,4-.8525v1.3525c0,.5288-1.5186,1.5-4,1.5Zm0-4c-2.4814,0-4-.9712-4-1.5v-1.3525c1.0469.5342,2.4331.8525,4,.8525s2.9531-.3184,4-.8525v1.3525c0,.5288-1.5186,1.5-4,1.5Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m30,15.5c0,3.08-2.14,5.65-5.0099,6.3199v-2.0699c1.75-.62,3.0099-2.28,3.0099-4.25,0-2.33-1.83-4.29-4.15-4.4801l-.81-.0599-.1-.8099c-.43-3.5-3.42-6.15-6.94-6.15-3.53,0-6.52,2.65-6.95,6.15l-.1.8099-.81.0599c-2.32.1901-4.14,2.1501-4.14,4.4801,0,1.96,1.25,3.62,2.9901,4.24v2.08c-2.86-.6799-4.9901-3.25-4.9901-6.3199,0-3.1,2.22-5.75,5.2-6.36.86-4.1201,4.52-7.14,8.8-7.14,4.27,0,7.9301,3.0199,8.8,7.14,2.97.61,5.2,3.26,5.2,6.36Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2.propTypes = iconPropTypes;
}
const IbmDb2Alt = /*#__PURE__*/React.forwardRef(function IbmDb2Alt(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2Alt.propTypes = iconPropTypes;
}
const IbmDb2Warehouse = /*#__PURE__*/React.forwardRef(function IbmDb2Warehouse(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5039,17.6362l-6-3.5c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362l-6,3.5c-.3071.1792-.4961.5083-.4961.8638v7c0,.3555.189.6846.4961.8638l6,3.5c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l6-3.5c.3071-.1792.4961-.5083.4961-.8638v-7c0-.3555-.189-.6846-.4961-.8638Zm-1.5039,6.1978l-2.5317-1.519c.0132-.1045.0317-.207.0317-.3149,0-1.0225-.6187-1.9014-1.5-2.2881v-2.9707l4,2.333v4.7598Zm-6-7.0928v2.9707c-.8813.3867-1.5,1.2656-1.5,2.2881,0,.1079.0186.2104.0317.3149l-2.5317,1.519v-4.7598l4-2.333Zm1,11.1011l-3.9517-2.3052,2.5071-1.5039c.4087.291.9055.4668,1.4446.4668s1.0359-.1758,1.4446-.4668l2.5071,1.5039-3.9517,2.3052Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m24.8,9.14c-.87-4.12-4.52-7.14-8.8-7.14s-7.93,3.02-8.8,7.14c-2.97.6-5.2,3.26-5.2,6.36,0,3.07,2.14,5.63,5,6.31v-2.11c-1.74-.62-3-2.24-3-4.2,0-2.33,1.82-4.31,4.14-4.49l.82-.06.1-.81c.43-3.5,3.41-6.14,6.94-6.14s6.51,2.64,6.94,6.14l.1.81.82.06c2.32.19,4.14,2.16,4.14,4.49,0,1.95-1.26,3.59-3,4.21v2.11c2.86-.68,5-3.26,5-6.32,0-3.11-2.23-5.76-5.2-6.36Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2Warehouse.propTypes = iconPropTypes;
}
const IbmDeployableArchitecture = /*#__PURE__*/React.forwardRef(function IbmDeployableArchitecture(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M29,18c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2ZM24,4c0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2,2-.9,2-2ZM24,28c0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2,2-.9,2-2ZM25,15h-4.11c1.3-1.27,2.11-3.04,2.11-5v-2h-2v2c0,2.76-2.24,5-5,5h-7v2h7c2.76,0,5,2.24,5,5v2h2v-2c0-1.96-.81-3.73-2.11-5h4.11v-2ZM11.63,20.29l-.04.02-1.31.77-1.28.76-5-2.96v-5.76l5-2.96,1.28.76,1.31.77.04.02,1.71,1.02,1.02-1.72-1.71-1.02-.04-.02-1.33-.78-1.77-1.05c-.16-.09-.33-.14-.51-.14s-.35.05-.51.14l-6,3.55c-.3.18-.49.51-.49.86v6.9c0,.35.19.68.49.86l6,3.55c.16.09.33.14.51.14s.35-.05.51-.14l1.77-1.05,1.33-.78.04-.02,1.71-1.02-1.02-1.72-1.71,1.02Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDeployableArchitecture.propTypes = iconPropTypes;
}
const IbmDynamicRouteServer = /*#__PURE__*/React.forwardRef(function IbmDynamicRouteServer(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "5",
    r: "2"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "27",
    r: "2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m7,13H1v6h6v-6Zm-2,4h-2v-2h2v2Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m17.4999,6.6774c-1.316-1.67-3.3437-2.6774-5.4999-2.6774-2.4907,0-4.8135,1.3403-6.063,3.499l-1.1655,2.0186,1.7324,1,1.165-2.0176c.8921-1.542,2.5518-2.5,4.3311-2.5s3.439.958,4.3311,2.4995c.0048.0082.011.0154.0158.0236l-1.9328,3.348c-1.1128,1.9282-3.188,3.1274-5.415,3.1289l.001,1-.001,1c2.2271.002,4.3022,1.2002,5.415,3.1289l1.9326,3.347c-.0049.0084-.0112.0156-.0161.024-.8916,1.542-2.5513,2.5-4.3306,2.5s-3.439-.958-4.3306-2.499l-1.165-2.0186-1.7324,1,1.1655,2.0195c1.249,2.1572,3.5718,3.498,6.0625,3.498,2.1555,0,4.1829-1.0075,5.5004-2.6772,1.3154,1.6699,3.3427,2.6772,5.4996,2.6772h2v-2h-2c-1.7387,0-3.3566-.918-4.2612-2.3972.9349-1.003,2.254-1.6018,3.6547-1.6018h2.6064v-2h-2.6064c-1.7564,0-3.4199.6761-4.6906,1.824l-1.5565-2.6961c-.7776-1.3467-1.9164-2.4129-3.2465-3.1289,1.3301-.716,2.4688-1.7822,3.2465-3.1289l1.5565-2.6962c1.2706,1.1483,2.9341,1.8246,4.6906,1.8246h2.6064v-2h-2.6064c-1.4005,0-2.7194-.5986-3.6552-1.6017.9044-1.4795,2.5226-2.3978,4.2616-2.3978h2v-2h-2c-2.157,0-4.1844,1.0074-5.5001,2.6774Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDynamicRouteServer.propTypes = iconPropTypes;
}
const IbmEloAutomotiveCompliance = /*#__PURE__*/React.forwardRef(function IbmEloAutomotiveCompliance(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.9467,13.9356h-2c-.7368,0-1.3748.4051-1.7218,1H6.0151l2.625-7h7.3073v-2h-7.3073c-.8291,0-1.5811.521-1.873,1.2974l-2.5137,6.7026-2.3066-.0005v2l2,.0002v9.0002c0,1.103.8975,2,2,2v3h2v-3h16v3h2v-3c1.1025,0,2-.897,2-2v-9h2v-2ZM5.9467,24.9356v-3h3v-2h-3v-3h20v3h-3v2h3v3H5.9467Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M11.979 19.941H19.979V21.941H11.979zM29.5367 2.5256L22.9467 9.1154 20.3567 6.5255 18.9467 7.9356 22.9467 11.9356 30.9467 3.9356 29.5367 2.5256z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloAutomotiveCompliance.propTypes = iconPropTypes;
}
const IbmEloEngineeringInsights = /*#__PURE__*/React.forwardRef(function IbmEloEngineeringInsights(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,16c-.0925,0-.1792.021-.27.0273l-.8916-2.6743c.7017-.5493,1.1616-1.3945,1.1616-2.353,0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,.3804.0784.7412.208,1.0762l-2.7224,2.333c-.4399-.2529-.9426-.4092-1.4856-.4092-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.9915,0,1.865-.4893,2.4116-1.2324l3.6038,1.0811c-.002.0513-.0154.0996-.0154.1514,0,2.2056,1.7944,4,4,4s4-1.7944,4-4-1.7944-4-4-4Zm-3-6c.5513,0,1,.4487,1,1s-.4487,1-1,1-1-.4487-1-1,.4487-1,1-1Zm-7,8c-.5513,0-1-.4487-1-1s.4487-1,1-1,1,.4487,1,1-.4487,1-1,1Zm2.9849-1.1484c-.0161-.3257-.0806-.6372-.1929-.9277l2.7224-2.333c.4243.2441.908.3936,1.4294.4033l.885,2.6553c-.5046.3281-.9229.7695-1.2363,1.2842l-3.6077-1.082Zm7.0151,5.1484c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M27.4961 9.8638l-11.4961-6.7061-8.4961 4.9561-1.0078-1.7275L15.4961 1.1362c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7-1.0078 1.7275zM16.5039 30.8638l-1.0078-1.7275 11.5039-6.7106v-10.4257h2v11c0 .3557-.189.6846-.4961.8638l-12 7zM12.4961 29.1138l-9-5.25c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l8.5039 4.9606-1.0078 1.7275z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloEngineeringInsights.propTypes = iconPropTypes;
}
const IbmEloMethodComposer = /*#__PURE__*/React.forwardRef(function IbmEloMethodComposer(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13.76,10.463l-3.297,3.297c-.6173.6173-.6173,1.6227,0,2.24l12.0044,12h5.5326v-5.5326l-12-12.0044c-.6173-.6173-1.6226-.6173-2.2399,0h0Zm12.24,12.8328v2.7042h-2.7042l-7.4409-7.4409,2.7042-2.7042,7.4409,7.4409Zm-8.855-8.8549l-2.7041,2.7041-2.2672-2.2672,2.7042-2.7042,2.2671,2.2673Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,2v8h-8v-2h4.92c-2.25-2.53-5.46-4-8.92-4-6.61,0-12,5.38-12,12,0,6.61,5.39,12,12,12h1v2h-1c-7.72,0-14-6.28-14-14S8.28,2,16,2c3.83,0,7.4,1.5499,10,4.23V2h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloMethodComposer.propTypes = iconPropTypes;
}
const IbmEloPublishing = /*#__PURE__*/React.forwardRef(function IbmEloPublishing(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M18 26L26.1719 26 23.5859 28.5859 25 30 30 25 25 20 23.5859 21.4141 26.1719 24 18 24 18 26zM10 21H15V23H10zM10 16H20V18H10z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24.7,9.3l-7-7c-.2-.2-.4-.3-.7-.3H7c-1.1,0-2,.8999-2,2v24c0,1.103.8975,2,2,2h8v-2h-8V4h8v6c0,1.1001.9,2,2,2h6v6h2v-8c0-.3-.1-.5-.3-.7Zm-7.7.7v-5.6001l5.6,5.6001h-5.6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloPublishing.propTypes = iconPropTypes;
}
const IbmEngineeringLifecycleMgmt = /*#__PURE__*/React.forwardRef(function IbmEngineeringLifecycleMgmt(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m31,22v-2h-2.1006c-.1299-.6372-.3845-1.2285-.7322-1.7529l1.4895-1.4897-1.4141-1.4141-1.4897,1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141,1.4141,1.4893,1.4897c-.3477.5244-.6021,1.1157-.7319,1.7529h-2.1006v2h2.1006c.1299.6372.3843,1.2285.7319,1.7532l-1.4893,1.4895,1.4141,1.4141,1.4897-1.4897c.5244.3477,1.1157.6021,1.7529.7319v2.1011h2v-2.1011c.6372-.1299,1.2285-.3843,1.7529-.7319l1.4897,1.4897,1.4141-1.4141-1.4895-1.4895c.3479-.5247.6023-1.116.7322-1.7532h2.1006Zm-7,2c-1.6567,0-3-1.3433-3-3s1.3433-3,3-3c1.6567,0,3,1.3433,3,3s-1.3433,3-3,3Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,6c0-2.7568-2.2432-5-5-5-1.7798,0-3.439.9575-4.3306,2.4995-.3201.5535-.5259,1.146-.6289,1.7944-1.1428-.8115-2.5352-1.2939-4.0405-1.2939C3.1401,4,0,7.1401,0,11c0,2.6981,1.5368,5.0403,3.7787,6.2083-1.0787.918-1.7787,2.2679-1.7787,3.7917,0,2.7568,2.2432,5,5,5,.7344,0,1.4265-.1685,2.0552-.4539.2764,2.4973,2.375,4.4539,4.9448,4.4539,1.335,0,2.5908-.52,3.5356-1.4639l-1.4141-1.415c-.5669.5669-1.3203.8789-2.1216.8789-1.6543,0-3-1.3457-3-3s1.3457-3,3-3v-2c-.7344,0-1.4265.1685-2.0552.4539-.1435-1.2966-.7849-2.4395-1.7218-3.2463,2.241-1.1685,3.777-3.51,3.777-6.2075,0-.1472-.0139-.2911-.0229-.4363.6199.2761,1.3018.4363,2.0229.4363,2.7568,0,5-2.2432,5-5Zm-7.5991-1.4995c.5352-.9253,1.5312-1.5005,2.5991-1.5005,1.6543,0,3,1.3457,3,3s-1.3457,3-3,3-3-1.3457-3-3h-.0293c.0352-.5762.1714-1.0522.4302-1.4995Zm-3.4009,16.4995c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3,1.3457-3,3-3,3,1.3457,3,3Zm-3-5c-2.7568,0-5-2.2432-5-5s2.2432-5,5-5,5,2.2432,5,5-2.2432,5-5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringLifecycleMgmt.propTypes = iconPropTypes;
}
const IbmEngineeringRequirementsDoorsNext = /*#__PURE__*/React.forwardRef(function IbmEngineeringRequirementsDoorsNext(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,4h-3v1.9991l3-.0005v20.0015h-3v2h3c1.103,0,2-.897,2-2V6c0-1.103-.897-2-2-2Z"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "17",
    r: "2",
    strokeWidth: "0"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22,4v24c0,1.103-.897,2-2,2H4c-1.103,0-2-.897-2-2V4c0-1.103.897-2,2-2h16c1.103,0,2,.897,2,2ZM4,28h16s0-24.0015,0-24.0015l-16,.0015v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringRequirementsDoorsNext.propTypes = iconPropTypes;
}
const IbmEngineeringSystemsDesignRhapsody = /*#__PURE__*/React.forwardRef(function IbmEngineeringSystemsDesignRhapsody(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 10h4c1.1046 0 2-.8954 2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046 0-2 .8954-2 2v4c0 1.1046.8954 2 2 2zm0-6h4v4h-4v-4zM28 22h-4c-1.1046 0-2 .8954-2 2v4c0 1.1046.8954 2 2 2h4c1.1046 0 2-.8954 2-2v-4c0-1.1046-.8954-2-2-2zm0 6h-4v-4h4v4zM21.414 12.586l-1.414 1.414 6 6 6-6-1.414-1.414-3.586 3.586V7c0-1.1046-.8954-2-2-2h-13v2h13v9.172l-3.586-3.586zM7 15.828l3.586 3.586 1.414-1.414-6-6L0 18l1.414 1.414 3.586-3.586v9.172c0 1.1046.8954 2 2 2h13v-2H7v-9.172z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringSystemsDesignRhapsody.propTypes = iconPropTypes;
}

export { FolderShared, Folders, ForecastHail, ForecastHail_30, ForecastLightning, ForecastLightning_30, Fork, ForkNode, Forum, Forward_10, Forward_30, Forward_5, Fragile, Friendship, FruitBowl, Function, FunctionMath, Function_2, GameConsole, GameWireless, Gamification, GasStation, GasStationFilled, Gateway, GatewayApi, GatewayMail, GatewayPublic, GatewaySecurity, GatewayUserAccess, GatewayVpn, Gears, Gem, GemReference, GenderFemale, GenderMale, GeneratePdf, Gif, Gift, GlobalLoanAndTrial, Globe, Gradient, GraphicalDataFlow, Grid, Group, GroupAccess, GroupAccount, GroupObjects, GroupObjectsNew, GroupObjectsSave, GroupPresentation, GroupResource, GroupSecurity, Growth, Gui, GuiManagement, Hail, Harbor, HardwareSecurityModule, Hashtag, Haze, HazeNight, Hd, HdFilled, Hdr, Headphones, Headset, HealthCross, Hearing, HeatMap, HeatMapStocks, HeatMap_02, HeatMap_03, Helicopter, Help, HelpDesk, HelpFilled, HexagonOutline, HexagonSolid, HexagonVerticalOutline, HexagonVerticalSolid, Home, HorizontalView, Hospital, HospitalBed, Hotel, Hourglass, Html, HtmlReference, Http, Humidity, HumidityAlt, Hurricane, HybridNetworking, HybridNetworkingAlt, IbmAiOnZ, IbmAiopsInsights, IbmApiConnect, IbmAppConnectEnterprise, IbmAspera, IbmBluepay, IbmCloudant, IbmContentServices, IbmDataPower, IbmDataProductExchange, IbmDataReplication, IbmDatastage, IbmDb2, IbmDb2Alt, IbmDb2Warehouse, IbmDeployableArchitecture, IbmDynamicRouteServer, IbmEloAutomotiveCompliance, IbmEloEngineeringInsights, IbmEloMethodComposer, IbmEloPublishing, IbmEngineeringLifecycleMgmt, IbmEngineeringRequirementsDoorsNext, IbmEngineeringSystemsDesignRhapsody, QH, QHintonPlot, WatsonHealthFusionBlender, WatsonHealthHangingProtocol, WatsonHealthHl7Attributes, WatsonHealthHoleFilling, WatsonHealthHoleFillingCursor };
